module.exports = __webpack_public_path__ + "img/taixiu_game_info.34890089.png";